import { merge } from "lodash-es";
import i18n from "../lib/i18n";

const defaultConfig = {
  render: {
    option_create: (data, escape) => {
      return `
        <div class="create">
          ${i18n.t("js.config.tom_select.add_item")}
          <strong>${escape(data.input)}</strong>&hellip;
        </div>
      `.trim();
    },
    no_results: () => {
      return `
        <div class="no-results">
          ${i18n.t("js.config.tom_select.no_results")}
        </div>
      `.trim();
    },
  },
  onInitialize: () => {
    // Fix styling of clear_button plugin
    document.querySelectorAll(".plugin-clear_button").forEach((item) => {
      item.classList.remove("plugin-clear_button");
    });
  },
  refreshThrottle: 0,
};

const defaultConfigTags = merge(
  {},
  { ...defaultConfig },
  {
    create: false,
    delimiter: null,
    controlClass: "chip-container mt-16",
    closeAfterSelect: true,
    plugins: {
      remove_button: {
        label: '<i class="fa fa-close"></i>',
        title: i18n.t("js.helpers.delete"),
      },
    },
    preload: "focus",
    render: {
      item: (data, escape) => {
        return '<span class="chip">' + escape(data.text) + "</span>";
      },
      no_results: null,
    },
    onInitialize: () => {
      // Fix styling of remove_button plugin
      document.querySelectorAll(".plugin-remove_button").forEach((item) => {
        item.classList.remove("plugin-remove_button");
      });
    },
  }
);

export { defaultConfig, defaultConfigTags };
